import Phaser from 'phaser';


export default class EggWord{

    constructor(){
        this.scene = GAME_REF.scene;

        this.item = null;
        this._init();
    }


    render(key, x, y){
        this._create(key, x, y);
        this._anime();
        GAME_REF.obj.sound.playOne(`na_${key}`);
    }
    
    
    destroy(){
        this.item.destroy();
        this.item = null;
    }


    _init(){
    }


    _create(key, x, y){
        this.item = this.scene.add.image(x, y+140, `ans_${key}`);
        this.item.setOrigin(0.5, 0.5);
        this.item.setDepth(20);
        this._ensureInViewport();
    }


    _ensureInViewport(){
        const viewportWidth = this.scene.game.config.width;
        const viewportHeight = this.scene.game.config.height;
        const halfWidth = this.item.displayWidth * 0.5;
        const halfHeight = this.item.displayHeight * 0.5;
    
        if(this.item.x - halfWidth < 0){
            this.item.x = halfWidth + 10;
        }
        else if(this.item.x + halfWidth > viewportWidth){
            this.item.x = viewportWidth - halfWidth -10;
        }
        
        if(this.item.y - halfHeight < 0){
            this.item.y = halfHeight + 10;
        } 
        else if(this.item.y + halfHeight > viewportHeight){
            this.item.y = viewportHeight - halfHeight -10;
        }
    }


    _anime(){
        this.item.alpha = 0;
        this.item.setScale(1.1);

        this.scene.tweens.add({
            targets: this.item,
            alpha: 1,
            scaleX: 1,
            scaleY: 1,
            duration: 700,
            delay: Math.floor(Math.random() * 500),
            ease: 'Cubic.easeOut'
        });
    }
}